export default "__VITE_ASSET__CkzFCCqk__"